export class OpenMenu {
  static readonly type = '[MENU] Open';
}

export class CloseMenu {
  static readonly type = '[MENU] Close';
}

export class SetRegularMenuItems {
  static readonly type = '[MENU] Set Regular Menu Items';
}

export class SetAdminMenuItem {
  static readonly type = '[MENU] Set Admin Menu Item';
}
